import React, { useState, useEffect } from "react";
import { Modal, Form, Select, InputNumber, Button } from "antd";

const { Option } = Select;

const IceClassModal = ({ visible, onClose, onSubmit, initialData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && initialData) {
      form.setFieldsValue({
        iceClassType: initialData.iceClassType || undefined,
        iceDistance: initialData.iceDistance || undefined,
      });
    }
  }, [visible, initialData, form]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit({
          iceClassType: values.iceClassType,
          iceDistance: values.iceDistance,
        });
        form.resetFields();
      })
      .catch((error) => {
        console.error("Validation failed:", error);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Ice Class Configuration"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Confirm
        </Button>,
      ]}
      width={300}
      destroyOnClose
      centered
    >
      <Form
        form={form}
        layout="vertical"
        className="ice-class-form"
      >
        <Form.Item
          label="Ice Class Type"
          name="iceClassType"
          rules={[
            {
              required: true,
              message: "Please select ice class type",
            },
          ]}
        >
          <Select
            placeholder="Select ice class type"
            size="large"
          >
            <Option value="IA SUPER">IA SUPER</Option>
            <Option value="IA">IA</Option>
            <Option value="IB">IB</Option>
            <Option value="IC">IC</Option>
            <Option value="none">None</Option>
           
          </Select>
        </Form.Item>

        <Form.Item
          label="Ice Class Distance"
          name="iceDistance"
          rules={[
            {
              required: true,
              message: "Please enter ice class distance",
            },
            {
              type: "number",
              min: -1,
              message: "Distance must be greater than 0",
            },
          ]}
        >
          <InputNumber
            placeholder="Enter distance"
            style={{ width: "100%" }}
            
            min={0}
            size="large"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default IceClassModal;
